import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Breadcrumbs,
  Link,
  Divider,
  useMediaQuery,
  Fab,
  Tooltip
} from "@mui/material";
import { Spin, Typography, Card, Skeleton } from "antd";
import { StarFilled, MessageOutlined } from "@ant-design/icons";
import ProductSectionNew from "../../components/common/ProductSectionNew";
import BestValueProductSection from "../../components/common/BestValueProductSection";
import TopValuePicksComparison from  "../../components/common/TopValuePicksComparison";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import joyLogo from "../../assests/Images/joyLogo.png";
import "./ProductPage.css";
import ProductListSection from "../../components/common/ProductListSection";
import HomeIcon from "../../assests/Images/home.svg";
import WebIcon from "../../assests/Images/web.svg";
import LogoIcon from "../../assests/Images/kangaroo.webp";
import SearchIcon from "../../assests/Images/list.svg";
import { SidebarNav, MobileBottomNav } from "../../components/common/ChatNavigation.js";
import ProductSkeleton from "../../components/common/ProductSkeleton.js";
import logoIcon from "../../assests/Images/kangaroo.webp"
import { trackingService } from "../../services/api/trackingService.js";


export default function TextrooLinkRender({loadingSkeleton=false,partialData,phone,productId,keyword}) {
  let { phoneNumber, id,adminView } = useParams();

  console.log("adminView",adminView)

  if (!phoneNumber && !id && !loadingSkeleton){
    phoneNumber=phone;
    id=productId;
  }
  // phoneNumber="+913230795798";
  // id="f879c2a016144d78a535b3d51c3e370f";
  // phoneNumber="";
  // id="";
  // loadingSkeleton=true

  // partialData=[
  //   {"asin": null,"image": "https://i5.walmartimages.com/seo/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz_e0381642-9489-4690-bc57-d4fd6e1dad53.0bf9af70aa26af70425c00bcdb784441.jpeg","key": "2LD84696JNJL","link": "https://www.walmart.com/ip/Valhalla-Java-Odinforce-Blend-Strong-Whole-Bean-Coffee-12-oz/585856048?classType=REGULAR","price": "14.99","rating": "4.9","reviews": "2684","store": "Walmart","title": "Valhalla Java Odinforce Blend Strong Whole Bean Coffee, 12 oz"},
  //     {"asin":"B007PM9YNA","image": "https://m.media-amazon.com/images/I/71BP8kUMVPL._AC_UL320_.jpg","key": "B007PM9YNA","link": "https://www.amazon.com/Kauai-Whole-Coffee-Estate-Medium/dp/B007PM9YNA/?tag=meetpoppins-20","price": "7.68","rating": "4.4","reviews": "1900","store": "Amazon","title": "Kauai Coffee Koloa Estate Medium Roast - Whole Bean Coffee, 10 oz Package"},
  //     {"asin":"","image": "","key": "","link": "","price": "","rating": "","reviews": "","store": "","title": ""},
  //  ]
  const { Text } = Typography;
  const isDesktop = useMediaQuery("(min-width:768px)");
  const [activeNav, setActiveNav] = useState(2);

  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [comparisonData,setComparisonData] = useState([]);


  const bottomNavHeight = isDesktop ? 0 : 0;
  const icons = [WebIcon, LogoIcon, SearchIcon];
  const routes = [
    "https://www.shopperoo.us/",
    "/chatbot",
    "/shopping",
  ];

  // Function to handle back to messaging app
  const handleBackToMessages = () => {
    phoneNumber = process.env.REACT_APP_ROO_PHONE
    // For SMS
    if (phoneNumber) {
      window.location.href = `sms:${phoneNumber}`;
    } else {
      // Fallback - try to open default messaging app
      window.location.href = 'sms:';
    }
  };

  useEffect(() => {
    if (!phoneNumber && !id ) return;
    setLoading(true);
    UIRecommendationAPIService.uiRecommend(phoneNumber, id)
      .then((response) => {
        setProductData(response || {})

        if (phoneNumber && response && ! adminView) {
          trackingService.trackPageVisit(
            phoneNumber,
            id || 'unknown',
            response?.keywords || response?.display_keywords || 'unknown'
          );
        }

        comparisonData.push(response?.top_rated_products?.[0])
        comparisonData.push(response?.lowest_priced_products?.[0])
        comparisonData.push(response?.best_value_products?.[0])

      })
      .catch((err) => console.error("Error fetching product data:", err))
      .finally(() => setLoading(false));
  }, [phoneNumber, id]);

  if (loading) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
      }}
    >
      <Box
        sx={{
          fontSize: 60,
          color: "#ff007f",
          animation: "bounce 1s infinite",
          "@keyframes bounce": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-10px)" },
          },
        }}
      >
        <img src={logoIcon} style={{ width: "60px", height: "60px" }} />
      </Box>

      {/* Use a standard div with explicit font styles instead of Typography */}
      <div
        style={{
          fontSize: "16px",
          fontWeight: "400",
          color: "#333",
          textAlign: "center",
          maxWidth: "400px",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          // Force font rendering
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        }}
      >
        {loadingSkeleton ? "Loading" : "Displaying your results…"}
      </div>
    </Box>
  );
}
  function formatWithOrdinal(num) {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  const date = new Date(productData?._ts * 1000);

  const day = formatWithOrdinal(date.getUTCDate());
  const month = date.toLocaleString("en-GB", { month: "long", timeZone: "UTC" });
  const year = date.getUTCFullYear();

  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  const formattedDate = `${day} ${month} ${year}, ${hours}:${minutes} UTC`;


  return (
    <>
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "white", padding: "10px" }}>
        {!productData && !partialData ? (
          <p style={{ textAlign: "center", marginTop: "4rem" }}>No data available</p>
        ) : (
          <main
            className="product-link-rendering-section-new"
            style={{
              flex: 1,
              overflowY: "auto",
              paddingBottom: !isDesktop ? bottomNavHeight : 0,
            }}
          >


            <TopValuePicksComparison
              products={productData?.comparison_data}
              bestValueProducts={comparisonData}
              partialData={loadingSkeleton ? partialData : []}
              keyword={productData?.display_keywords || keyword}
              websiteDisplay={false}
              date={formattedDate}
              phoneNumber={phoneNumber}
            />



            <ProductListSection
              bestValueProducts={productData?.best_value_products}
              topRatedProducts={productData?.top_rated_products}
              lowestPricedProducts={productData?.lowest_priced_products}
              loadingSkeleton={loadingSkeleton}
              phoneNumber={phoneNumber}
              amazonSavingamount={productData?.amazon_savings_amount}
              amazonSavingPercentage={productData?.amazon_savings_percent}
            />

          </main>
        )}
      </Box>

      {/* Floating Button - Only show on mobile */}
      {!isDesktop && (
        <Tooltip title="Back to Messages" placement="left">
          <Fab
            color="primary"
            aria-label="back to messages"
            onClick={handleBackToMessages}
            sx={{
              position: "fixed",
              bottom: 10,
              right: 12,
              zIndex: 1000,
              bgcolor: "black",
              "&:hover": {
                bgcolor: "black",
              },
              minWidth:"94%",
              left:"12px",
              height:"40px",
              borderRadius:"10px"
            }}
          >
            ← Back to Roo: Refine + Buy/Wait Advice
            {/* <MessageOutlined style={{ fontSize: "24px", color: "white" }} /> */}
          </Fab>
        </Tooltip>
      )}
    </>
  );
}